import { render } from "./login-activities.vue?vue&type=template&id=bbdb8322"
import script from "./login-activities.vue?vue&type=script&lang=js"
export * from "./login-activities.vue?vue&type=script&lang=js"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__